export default {
  picture: "pictures",
  company: "company",
};
